module.exports = __webpack_public_path__ + "img/17.1088bbd4.png";